import { atom } from "recoil";
export const AgentsAtom = atom({
  key: "AgentsAtom", // unique ID (with respect to other atoms/selectors)
  default: [], // default value (aka initial value)
});
